import React, { useState, useEffect } from "react";
import "./Navbar.css";
import logo_jaune from "../Resources/pictogrammes/cddp-jaune.svg";
import navicon from "../Resources/pictogrammes/iconnav_white.min.svg";
import { Link } from "react-router-dom";

import { FaireunDonNoir, CoursesTerminees } from "../Fonctions.js"


export default function Navbar() {
  const mobile_size = 800
  const [toggleMenu, setToggleMenu] = useState(false);
  const [largeur, setLargeur] = useState(window.innerWidth);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= mobile_size);
  const xactiveResults = CoursesTerminees()
  const activeResults = true

  const toggleNavSmallScreen = () => {
    setToggleMenu(!toggleMenu);
  };

  useEffect(() => {
    const changeWidth = () => {
      setLargeur(window.innerWidth);
      if (window.innerWidth > mobile_size) {
        setToggleMenu(false);
      }
    };

    window.addEventListener("resize", changeWidth);

    return () => {
      window.removeEventListener("resize", changeWidth);
    };
  }, []);
  const ScrollToDiv = () => {
    useEffect(() => {
        const observer = new MutationObserver((mutations, obs) => {
        const targetDiv = document.getElementById("scrollto_programme");
        setIsMobile(window.innerWidth <= mobile_size);
        if (targetDiv && isMobile) {
          targetDiv.scrollIntoView({ behavior: "smooth" });
          obs.disconnect(); // Stopper l'observation après le scroll
        }
      });
  
      observer.observe(document.body, { childList: true, subtree: true });
  
      return () => observer.disconnect(); // Nettoyage en cas de démontage
    }, []);
}  

  return (
    <nav className="navbar-static-top">
      {(toggleMenu || largeur > mobile_size) && (
        <ul className="list">
          <img className="logocddp" src={logo_jaune} alt="" />
          <Link to="/">
            <li className="items" onClick={toggleNavSmallScreen}><span className="arc">A</span>ccueil</li>
          </Link>
            {/* <Link to="course">
              <li className="items" onClick={toggleNavSmallScreen}>Inscriptions</li>
            </Link> */}
          { activeResults ? (
            <Link to="courseterminee">
              <li className="items" onClick={toggleNavSmallScreen}>Résultats</li>
            </Link>
          ) : (
            <Link to="course">
              <li className="items" onClick={toggleNavSmallScreen}>Inscriptions</li>
            </Link>
          )
           }
          <Link to="ambassadeurs">
            <li className="items" onClick={toggleNavSmallScreen}>Ambassadeurs</li>
          </Link>
          <Link to="recherche">
            <li className="items" onClick={toggleNavSmallScreen}>La <span className="arc">R</span>echerche</li>
          </Link>
          <Link to="partenaires">
            <li className="items" onClick={toggleNavSmallScreen}>Partenaires</li>
          </Link>
          <Link to="boutique">
            <li className="items" onClick={toggleNavSmallScreen}>Boutique</li>
          </Link>
          <Link to="contact">
            <li className="items" onClick={toggleNavSmallScreen}><span className="arc">C</span>ontacts</li>
          </Link>
          <FaireunDonNoir />
          <Link to="galerie">
            <li className="items" onClick={toggleNavSmallScreen}>Galerie</li>
          </Link>
        </ul>
      )}
      <img onClick={toggleNavSmallScreen} id="navicon" src={navicon} alt="" />
      {/* <ScrollToDiv></ScrollToDiv> */}
    </nav>
  );
}
